module.exports = __webpack_public_path__ + "img/arrow-simple-right-black.b8b437b2.svg";